<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>
        <div class="card">
            <div class="p-grid p-fluid">
                <div class="p-col-12 p-md-12 p-lg-2">
                    <label for="icon">Data Inical: </label>
                    <p-calendar [(ngModel)]="dataInicial" [showIcon]="true" inputId="icon" dateFormat="dd/mm/yy">
                    </p-calendar>
                </div>
                <div class="p-col-12 p-md-12 p-lg-2">
                    <label for="icon">Data Final:</label>
                    <p-calendar [(ngModel)]="dataFinal" [showIcon]="true" inputId="icon" dateFormat="dd/mm/yy">
                    </p-calendar>
                </div>
                <div class="p-col-12 p-md-12 p-lg-2" style="align-self: end">
                    <p-button label="Pesquisar" icon="pi pi-search" (click)="pesquisar()"></p-button>
                </div>
                <div class="p-col-12 p-md-12 p-lg-2" style="align-self: end;">
                    <button pButton pRipple type="button" label="Relatório" class="p-button-danger"
                        icon="pi pi-file-pdf" (click)="gerarRelatorioSintetico()">
                        <i *ngIf="RelatorioSintetico" class="pi pi-spin pi-spinner"></i>
                    </button>
                </div>
                <!-- <div class="p-col-12 p-md-12 p-lg-2" style="align-self: end;">
                    <button pButton pRipple type="button" label="Por Tempo" class="p-button-danger"
                    icon="pi pi-file-pdf" (click)="gerarRelatorioPorTempo()">
                    <i *ngIf="RelatorioPorHora" class="pi pi-spin pi-spinner"></i>
                </button>
                </div>
                <div class="p-col-12 p-md-12 p-lg-2" style="align-self: end;">
                    <button pButton pRipple type="button" label="Analítico" class="p-button-danger"
                        icon="pi pi-file-pdf" (click)="gerarRelatorioAnalitico()">
                        <i *ngIf="RelatorioAnalitico" class="pi pi-spin pi-spinner"></i>
                    </button>
                </div> -->
            </div>
        </div>

        <p-tabView>
            <p-tabPanel header="Atendimentos">
                <p-accordion>
                    <p-accordionTab header="Filtros" [selected]="true">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-col-12 p-md-6 p-lg-3">
                                <label class="labelBlackBold">Visita</label>
                                <p-dropdown [(ngModel)]="filtro_visita" [options]="visitas" optionLabel="descricao"
                                     optionValue="descricao" placeholder="Visita"></p-dropdown>
                            </div>
                            <div class="p-col-12 p-md-6 p-lg-3">
                                <label class="labelBlackBold">Elevador</label>
                                <p-dropdown [(ngModel)]="filtro_elevador" [options]="listaElevadores"
                                    optionLabel="descricao" optionValue="descricao" placeholder="Elevador">
                                </p-dropdown>
                            </div>
                            <!-- <div class="p-col-12 p-md-6 p-lg-3">
                                <label class="labelBlackBold">Elevador</label>
                                <input [(ngModel)]="filtro_elevador" type="text " pInputText
                                    (input)="dt.filter($event.target.value,'elevador','contains')">
                            </div> -->
                        </div>
                    </p-accordionTab>
                </p-accordion>
                <br>
                <div class="card">
                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loading"></p-progressBar>

                    <p-table #dt [value]="lista" [rows]="15" [paginator]="true"
                    [globalFilterFields]="['data','hora','endereco','elevador','visita','inicio','fechamento','mec','rsp','resolvido','plano_manut','turno']"
                        responsiveLayout="scroll" [rowsPerPageOptions]="[5,10,15]" scrollDirection="both"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [scrollable]="true"
                        scrollHeight="400px" styleClass="p-mt-3" [(selection)]="selecionados" [rowHover]="true"
                        dataKey="cod_usuario" [showCurrentPageReport]="false" selectionMode="single">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 5rem;" pSortableColumn="data_mec">Data
                                </th>
                                <!-- <th style="width: 5rem;" pSortableColumn="endereco">Endereço
                                </th> -->
                                <th style="width: 5rem;" pSortableColumn="elevador">Elevador
                                </th>
                                <th style="width: 5rem;" pSortableColumn="defeito">Defeito
                                </th>
                                <th style="width: 5rem;" pSortableColumn="visita">Visita
                                </th>
                                <th style="width: 5rem;" pSortableColumn="saida">Saída
                                </th>
                                <th style="width: 5rem;" pSortableColumn="mec">Mecânico
                                </th>
                                <th style="width: 5rem;" pSortableColumn="resolvido">Atendido
                                </th>
                                <th style="width: 5rem;" pSortableColumn="obs">Obs. Atendimento
                                </th>
                                <th style="width: 5rem;" pSortableColumn="pendencia_manut">Obs. Preventiva
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-dados>
                            <tr>
                                <td style="width: 5rem;">
                                    {{dados.data_mec}}
                                </td>
                                <!-- <td style="width: 5rem;">
                                    {{dados.endereco}}
                                </td> -->
                                <td style="width: 5rem;">
                                    {{dados.elevador}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.defeito}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.visita}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.saida}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.mec}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.resolvido}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.obs}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.pendencia_manut}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                Registros: {{lista? lista.length: 0}}
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Nota Fiscal">
                <div class="card">
                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loadingNotaFiscal"></p-progressBar>

                    <p-table #dt [value]="listaNotaFiscal" [rows]="15" [paginator]="true" responsiveLayout="stack"
                        [globalFilterFields]="['num_orcamento', 'nf', 'valor_iss', 'cliente', 'endereco', 'descricao', 'vencimento', 'data_pagamento', 'valor_pago', 'banco', 'parcela', 'valor_parcela', 'emissao', 'status']"
                        responsiveLayout="scroll" [rowsPerPageOptions]="[5,10,15]" scrollDirection="both"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [scrollable]="true"
                        scrollHeight="400px" styleClass="p-mt-3" [(selection)]="selecionadosNotaFiscal" [rowHover]="true"
                        dataKey="cod_contas_receber" [showCurrentPageReport]="false" selectionMode="single">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 5rem;" pSortableColumn="">Imprimir
                                </th>
                               <th style="width: 5rem;" pSortableColumn="nf">Nota Fiscal
                                </th>
                                <th style="width: 5rem;" pSortableColumn="valor_parcela">Valor
                                </th>
                                <th style="width: 5rem;" pSortableColumn="vencimento">Vencimento
                                </th>
                                <th style="width: 25rem;" pSortableColumn="descricao">Descrição
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-dados>
                            <tr>
                                <td style="width: 5rem;">
                                    <button pButton pRipple icon="pi pi-print" [disabled]="dados.nfse_url ? false : true"
                                        class="p-button-sm p-button-rounded p-button-success p-mr-2"
                                        (click)="imprimirNF(dados)"></button>
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.nf}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.valor_parcela | currency:'BRL':true}}
                                </td>
                                <td style="width: 5rem;">
                                    {{dados.vencimento | date:'dd/MM/yyyy'}}
                                </td>
                                <td style="width: 25rem;">
                                    {{dados.descricao}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                Registros: {{listaNotaFiscal? listaNotaFiscal.length: 0}}
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Boletos">
                <div class="card">
                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loadingNotaBoletoBancario"></p-progressBar>

                    <p-table #dt [value]="listaBoletoBancario" [rows]="15" [paginator]="true" responsiveLayout="stack"
                        [globalFilterFields]="['numero', 'nf', 'valor_iss', 'cliente', 'endereco', 'descricao', 'vencimento',
                        'data_pagamento', 'valor_pago', 'banco', 'parcela', 'valor_parcela', 'emissao', 'status']"
                        responsiveLayout="scroll" [rowsPerPageOptions]="[5,10,15]" scrollDirection="both"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [scrollable]="true"
                        scrollHeight="400px" styleClass="p-mt-3" [(selection)]="selecionadosBoletoBancario" [rowHover]="true"
                        dataKey="cod_contas_receber" [showCurrentPageReport]="false" selectionMode="single">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 5rem;">Imprimir</th>
                                <th style="width: 6rem;" pSortableColumn="status">Pago
                                </th>
                                <th style="width: 6rem;" pSortableColumn="boleto">Boleto
                                </th>
                                <th style="width: 6rem;" pSortableColumn="valor_parcela">Valor
                                </th>
                                <th style="width: 6rem;" pSortableColumn="vencimento">Vencimento
                                </th>
                                <th style="width: 25rem;" pSortableColumn="descricao">Descrição
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-dados>
                            <!-- <tr [style.background-color]="dados.status =='SIM' ? '#b6ff97' : verificarVencimento(dados)"> -->
                            <tr >
                                <td style="width: 5rem;">
                                    <button pButton pRipple icon="pi pi-print" [disabled]="dados.status == 'NÃO' ? false : true"
                                        class="p-button-sm p-button-rounded p-button-success p-mr-2"
                                        (click)="imprimirBoleto(dados)"></button>
                                </td>
                                <td style="width: 6rem;">
                                    {{dados.status}}
                                </td>
                                <td style="width: 6rem;">
                                    {{dados.boleto}}
                                </td>
                                <td style="width: 6rem;">
                                    {{dados.valor_parcela | currency:'BRL':true}}
                                </td>
                                <td style="width: 6rem;">
                                    {{dados.vencimento | date:'dd/MM/yyyy'}}
                                </td>
                                <td style="width: 25rem;">
                                    {{dados.descricao}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                Registros: {{listaBoletoBancario? listaBoletoBancario.length: 0}}
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>
        </p-tabView>


        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>
